module.exports = __webpack_public_path__ + "img/img22.06e623b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/img22.png
// module id = 367
// module chunks = 0